import Vue from 'vue'
import axios from 'axios'
import { Message, Notification } from 'element-ui'
import httpIp from '../utils/httpConfig'
import router from "../router";
import store from "../store";

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 配置接口地址
axios.defaults.baseURL = httpIp.ip
axios.interceptors.request.use(
  config => {
    config.headers.authorization = store.state.status.Authorization
    return config
  },
  err => {
    Message.error('请求错误')
    return Promise.reject(err)
  }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    if (res.status === 200 || res.status === 204 || res.status === 201) {
      return res
    } else {
      Message.error(res.data.data.msg||'网络错误')
      return res.data
    }
  },
  err => {
    if (err.response.status === 401 ){
      if (localStorage.getItem('user-info')) {
        localStorage.removeItem('user-info')
        localStorage.removeItem('Authorization')
        location.reload();
      }
    } else if (err.response.status === 500) {
      router.push({name:'Page500'})
    } else if (err.response.status === 404) {

      router.push({name:'Page404'})
    }else {
      Vue.prototype.$Bus.$emit('tips','提示',err.response.data.message)
    }
    return Promise.reject(err.response)
  }
)
// post请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err.data)
        }
      )
      .catch(err => {
        reject(err.data)
      })
  })
}

//get请求
export  function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

// delete 请求封装
export function deletefn(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params
      })
      .then(
        res => {
          resolve(res.data)
        }
      )
      .catch(err => {
        reject(err.data)
      })
  })
}

// put 请求封装
export function putfun(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then(
        res => {
          resolve(res.data)
        }
      )
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js